import { get } from './client.js';

export const getUsage = (orgId) => get(`/orgs/${orgId}/usage`);
